var indentation_default = {
  "indentZero": "wnotN",
  "indentOne": "RaIDY",
  "indentTwo": "jvzJF",
  "indentThree": "EYe1r",
  "indentFour": "KEWfu",
  "indentFive": "wMrTE",
  "indentSix": "df7Ll"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
